import {
  createPersonIndividual,
  isIndividualPersonType,
} from '~/api/constants/person';

const contactIcons = {
  phone: 'rz-icon-phone',
  email: 'rz-icon-mail',
  fax: 'rz-icon-print',
};

export default class Person {
  data = null;

  constructor (data) {
    this.data = data;
  }

  get id () {
    return this.data.id;
  }

  get account () {
    return this.data.accountNumber;
  }

  get address () {
    return this.data.address;
  }

  get city () {
    return this.data.city;
  }

  get country () {
    return this.data.country;
  }

  get expeditor () {
    return this.data.expeditor;
  }

  get name () {
    return this.data.name;
  }

  // Организационно-правовая форма. Пустое значение — юридическое лицо: так же
  // его трактует бэкенд, и до появления поля другого варианта не было.
  get type () {
    return this.data.type || '';
  }

  get isIndividual () {
    return isIndividualPersonType(this.type);
  }

  // ФИО есть только у ИП и физлица; у них же оно подставляется в `name`.
  get individual () {
    return createPersonIndividual(this.data.individual);
  }

  get inn () {
    return this.data.inn;
  }

  get kpp () {
    return this.data.kpp;
  }

  get innKpp () {
    let result = '';
    if (this.inn) result += this.inn;
    if (this.kpp) {
      if (this.inn) result += '/';
      result += this.kpp;
    }
    return result;
  }

  get postCode () {
    return this.data.postCode;
  }

  get contacts () {
    return this.data.contacts?.map(contact => {
      return {
        ...contact,
        icon: contactIcons[contact.type],
      };
    }) || [];
  }

  get fullName () {
    let result = `${this.name} \n${this.address}`;
    if (this.country) result += `\n${this.country}`;
    if (this.city) result += `${this.country ? ', ' : '\n'}${this.city}`;
    if (this.postCode) result += `\n${this.postCode}`;
    return result;
  }

  get isFilled () {
    return !!(
      this.name ||
      this.country ||
      this.city ||
      this.postCode ||
      this.innKpp ||
      this.address
    );
  }

  get inner () {
    return this.data.inner;
  }
};
